import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "shared/components/ui/select";
import constraintsStore from "shared/store/constraintsStore";
import colorsStore from "shared/store/colorsStore";

type DropdownProps = {
  label: string;
  options: any;
  defaultValue?: string;
  value?: string; // Added for controlled components
  onChange: (value: string) => void;
  /**
   * Canonical dotted field path for orange-border decoration when the
   * agent has touched this field. Matches the shape `agentChangedPaths`
   * carries (e.g. `"risk.financial_plan"`). Optional — pass when the
   * dropdown maps to a single savable field; omit for dropdowns that
   * are pure UI affordances (e.g. ESG preference, which is a
   * multi-step prelude to the per-letter checkboxes).
   */
  fieldPath?: string;
  disabled?: boolean;
};

export const Dropdown: React.FC<DropdownProps> = ({
  label,
  options,
  defaultValue,
  value,
  onChange,
  fieldPath,
  disabled = false,
}) => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  const agentChangedPaths = constraintsStore((s) => s.agentChangedPaths);

  const isAgentChanged = !!fieldPath && agentChangedPaths.includes(fieldPath);

  // User changing the dropdown value clears the orange border for that
  // field — same semantic as the panel inputs. Wrap the caller's
  // onChange to fire the acknowledge first, then propagate.
  const handleChange = (next: string) => {
    if (isAgentChanged && fieldPath) {
      constraintsStore.getState().acknowledgeFieldEdit(fieldPath);
    }
    onChange(next);
  };

  const borderColor = isAgentChanged ? colorsConfig.orange : "#8F949C";
  const borderSize = isAgentChanged ? 2 : 1;

  return (
    <div>
      {label && (
        <p
          style={{
            fontSize: "12px",
            color: colorsConfig.finecoBlack,
          }}
        >
          {label}
        </p>
      )}
      <Select
        value={value ?? defaultValue ?? undefined}
        onValueChange={(value) => handleChange(value)}
        disabled={disabled}
      >
        <SelectTrigger
          style={{
            width: "100%",
            padding: "1rem",
            borderRadius: "12px",
            border: borderSize + "px solid " + borderColor,
            backgroundColor: "#ffffff",
            fontSize: "12px",
          }}
        >
          <SelectValue placeholder="Select an option" />
        </SelectTrigger>
        <SelectContent
          style={{
            borderRadius: "12px",
            border: "1px solid #8F949C",
            backgroundColor: "#ffffff",
            zIndex: 101,
          }}
        >
          {options?.map((option) => (
            <SelectItem
              key={option}
              value={option}
              style={{
                padding: "0.6rem",
                fontSize: "12px",
                color: "#1f2937",
              }}
            >
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
